import type { ShipmentStatus } from '../../shipments/shipments-types.js';
import type { CounterpartySnapshot } from '../../counterparties/counterparties.dto.js';
import type { IncomingTransferReceiptStatus } from '../../inbound-receipts/inbound-receipts-types.js';

export const incomingTransferSyncEntityTypeValues = ['incomingTransfer'] as const;
export type IncomingTransferSyncEntityType = (typeof incomingTransferSyncEntityTypeValues)[number];

export const incomingTransferSyncEventTypeValues = ['incomingTransferUpserted'] as const;
export type IncomingTransferSyncEventType = (typeof incomingTransferSyncEventTypeValues)[number];

export interface IncomingTransferSyncPayloadBase {
  schemaVersion: 1;
  eventId: string;
  occurredAt: string;
  companyId: string;
  stationId: string;
  sourceShipmentId: string;
}

export interface IncomingTransferUpsertedEventPayload extends IncomingTransferSyncPayloadBase {
  sourceShipmentCompanyId: string;
  materialId: string;
  sourceShipmentStatus: ShipmentStatus;
  receiptStatus: IncomingTransferReceiptStatus;
  confirmedReceiptId: string | null;
  shipper: CounterpartySnapshot;
  receiver: CounterpartySnapshot;
  transferReference: string | null;
  reportRangeStartAt: string | null;
  reportRangeEndAt: string | null;
  shippedRedemptionWeightLb: number | null;
  shippedRefundValueCents: number | null;
  totalWeightLb: number | null;
  createdAt: string;
  departedAt: string | null;
  receiptConfirmedAt: string | null;
  receiptCanceledAt: string | null;
}
